let apiBaseUrl = "";
let socketUrl = "";

let appStage = process.env.REACT_APP_STAGE;

if (appStage == "dev") {
  apiBaseUrl = "https://irbackend.dreamztesting.com/api/v1/";
  socketUrl = "https://socket.insiderodeo.com:6670/";
} else if (appStage == "stage") {
  apiBaseUrl = "https://insiderodeo-api.stage.tetonridge.io/api/v1/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
} else if (appStage == "prod") {
  apiBaseUrl = "https://api.insiderodeo.com/api/v1/";
  socketUrl = "https://ws.insiderodeo.com/";
}

export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;

// Socket.IO transport configuration
// Prioritize WebSocket for mobile optimization (75% iOS users) with polling fallback
// WebSocket-first provides better performance while maintaining compatibility
export const SOCKET_TRANSPORTS = ['websocket', 'polling']; // WebSocket-first, polling fallback

